import type { ReactNode } from "react";

/**
 * One focal number. Per the principles, exactly one tile per screen should
 * carry `focal`.
 */
export function StatTile({ label, value, meta, progress, focal = false }: {
  label: ReactNode;
  value: ReactNode;
  meta?: ReactNode;
  /** 0-100. Renders a rule under the figure. */
  progress?: number;
  focal?: boolean;
}) {
  return (
    <div className={focal ? "stat-tile focal" : "stat-tile"}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {progress != null && (
        <span className="stat-bar"><i style={{ width: `${Math.min(100, Math.max(0, progress))}%` }} /></span>
      )}
      {meta && <div className="stat-meta">{meta}</div>}
    </div>
  );
}
